import { CompanySourcesTableCell } from 'shared/companySources/CompanySourcesCell';

/**
 * Normalizes company source data from row payloads for display in the company sources cell.
 */
const mapRowCompanySources = (row) => {
    const sources = row.companySources ?? [];

    return sources.map((source) => {
        const companySourceId = source?.companySourceId;
        const text = source?.companySourceName;

        return {
            ...source,
            id: companySourceId,
            text,
            value: companySourceId,
        };
    });
};

/**
 * @param {'externalSku' | 'packaging'} entityType
 */
const createCompanySourceColumn = ({ entityType, onRefresh, setNotification }) => ({
    accessor: 'companySources',
    Header: 'Company Sources',
    editable: false,
    filterValues: (row) => row.original.companySources.map((item) => item.text),
    Cell: CompanySourcesTableCell,
    companySourceCellProps: { entityType, onRefresh, setNotification },
});

export { createCompanySourceColumn, mapRowCompanySources };
